module.exports = "pegasus_template/assets/circle_icn_2.png";